import Polygon from '@arcgis/core/geometry/Polygon';
import React, { createContext, ReactElement, useState } from 'react'

type Props = {
    children: ReactElement
}

export const HistoryContext = createContext({} as IHistoryContext);

export interface IHistoryContext {
    statistics: any[],
    setStatistics: (newStats: any) => void,
    areaToInspect: Polygon | null,
    setAreaToInspect: (area: Polygon) => void,
    showNotificationsOnMap: boolean,
    setShowNotificationsOnMap: (showNotifications: boolean) => void
}

export default function HistoryContextContainer(props: Props) {
    const [statistics, setStatistics] = useState([]);
    const [areaToInspect, setAreaToInspect] = useState<Polygon | null>(null);
    const [showNotificationsOnMap, setShowNotificationsOnMap] = useState<boolean>(false);

    const setStatisticsCallback = (newStatistics: any) => {
        setStatistics(newStatistics);
    }

    const setAreaToInspectCallback = (area: Polygon) => {
        setAreaToInspect(area);
    }

    const setShowNotificationsOnMapCallback = (showNotifications: boolean) => {
        setShowNotificationsOnMap(showNotifications);
    }

    return (
        <HistoryContext.Provider value={{ statistics, setStatistics: setStatisticsCallback, areaToInspect, setAreaToInspect: setAreaToInspectCallback, showNotificationsOnMap, setShowNotificationsOnMap: setShowNotificationsOnMapCallback }}>
            {props.children}
        </HistoryContext.Provider>
    )
}